import { connect } from 'react-redux';

import { getProjectZoneId, getUnitsExecutionState } from '../../../reducers/analyticsApp';
import FunnelChart from '../../../components/dashboards/preview/FunnelChart';
import { views } from '../../../constants/event';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const { result } = unitExecute;

  return {
    data: (result || {}).chart,
    executeTime: unitExecute.executeTime,
    options: {
      timezone: getProjectZoneId(state),
    },
    view: views.CHART,
  };
};

const ConversionChart = connect(mapStateToProps, null)(FunnelChart);

export default ConversionChart;
